@value laptop from "@shared/styles/breakpoints.module.css";

.root {
  width: 100%;
  max-width: var(--layout-content-max);
  margin: 0 auto;
}

.layout {
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: laptop) {
    grid-template-columns: 1fr;
  }
}

.left {
  padding: clamp(var(--space-28), 4vw, var(--space-64)) var(--space-page);
  border-right: 1px solid var(--color-border);
  background: var(--color-bg);

  @media (max-width: laptop) {
    border-right: none;
    border-bottom: 1px solid var(--color-border);
  }
}

.right {
  padding: clamp(var(--space-28), 4vw, var(--space-64)) var(--space-page);
  background: var(--color-card);
}

.badge {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-bottom: var(--space-12);
}

.pageTitle {
  font-family: var(--font-heading);
  font-size: var(--type-page);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--color-text);
  margin-bottom: clamp(var(--space-24), 3vw, var(--space-40));
  line-height: 1.05;
}

.contactLabel {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-bottom: var(--space-5);
}

.contactValue {
  font-family: var(--font-heading);
  font-size: clamp(1rem, 1.8vw, 1.5rem);
  font-weight: 500;
  color: var(--color-text);
  margin-bottom: clamp(var(--space-18), 2.5vw, var(--space-28));

  /* телефон и почта — ссылки: tel: и mailto: открывают звонок и письмо */
  &:is(a) {
    display: block;
    width: fit-content;
    text-decoration: none;
    transition: color var(--motion-fast) ease;
  }
  @media (hover: hover) and (pointer: fine) {
    &:is(a):hover {
      color: var(--color-primary);
    }
  }
}

.map {
  height: clamp(280px, 25vw, 360px);
  border-radius: var(--radius-small);
  border: 1px solid var(--color-border);
  background: var(--color-card);
  margin-top: clamp(var(--space-20), 2.5vw, var(--space-32));
  overflow: hidden;
}

.mapFrame {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

.mapLink {
  display: inline-flex;
  align-items: center;
  gap: var(--space-6);
  margin-top: var(--space-12);
  font-size: var(--type-caption);
  color: var(--color-text);
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: color var(--motion-fast);

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--color-primary);
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

.contactValue[data-small="true"] {
  font-size: clamp(0.875rem, 1.2vw, 1.125rem);
}
